import React from 'react';
import core from '@gin-betting/core';

import Icon from '../Icon';
import backIcon from 'assets/svg/arrow-left.svg';
import './backButton.scss';

const {
    utils: { goBack },
} = core;

interface Props {}

const BackButton: React.FC<Props> = () => {
    return (
        <button onClick={goBack} styleName="back" className="__app-BackButton">
            <Icon glyph={backIcon} styleName="icon" />
        </button>
    );
};

export default BackButton;
